import { useSkeletonTranslation } from 'hooks/useSkeletonTranslation';
import type { FC } from 'react';

import { useAppCore } from '../../providers/AppCoreProvider/AppCoreContext';
import style from './CryptoSelectBlock.module.scss';
import type { SelectValue } from './Select/CurrencySelect';
import CurrencySelect from './Select/CurrencySelect';

interface CryptoSelectBlockProps {
  selectedCurrency: SelectValue | null;
  networkValue: SelectValue | null;
  onCurrencyClick: () => void;
  onNetworkClick: () => void;
  isOnlyOneCurrency: boolean;
  userBlocked?: boolean;
}

export const CryptoSelectBlock: FC<CryptoSelectBlockProps> = ({
  selectedCurrency,
  onCurrencyClick,
  onNetworkClick,
  networkValue,
  isOnlyOneCurrency,
  userBlocked,
}) => {
  const { translate } = useSkeletonTranslation();
  const { widgetData } = useAppCore();
  const { isLoading, data } = widgetData;
  const networks = data?.methods ?? [];
  const networksCount = networks.length;
  const isNetworksEmpty = networksCount === 0;
  const isOnlyOneNetwork = networksCount === 1;

  return (
    <div className={style.container}>
      <CurrencySelect
        selectedCurrency={selectedCurrency}
        fullWidth={false}
        label={translate('PH.SELECT.CURRENCY.LABEL')}
        onClick={onCurrencyClick}
        hideRigthIcon={isOnlyOneCurrency}
        dataTestId="currency-select"
      />
      <CurrencySelect
        selectedCurrency={networkValue}
        fullWidth={false}
        label={translate('PH.NETWORK')}
        onClick={onNetworkClick}
        isLoading={isLoading}
        disabled={isNetworksEmpty || isOnlyOneNetwork || userBlocked}
        hideRigthIcon={isOnlyOneNetwork}
        dataTestId="network-select"
      />
    </div>
  );
};
